import { render, staticRenderFns } from "./SalesPublishListList.vue?vue&type=template&id=64c5cc28&scoped=true&"
import script from "./SalesPublishListList.vue?vue&type=script&lang=js&"
export * from "./SalesPublishListList.vue?vue&type=script&lang=js&"
import style0 from "./SalesPublishListList.vue?vue&type=style&index=0&id=64c5cc28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5cc28",
  null
  
)

export default component.exports